import React, { useEffect, useState } from "react";
import { getSettingJson } from "../apis/config";

const AboutUs = () => {
  const [data, setData] = useState({
    phone: "",
    phone1: "",
    phone2: "",
    email: "",
    terms: "",
    returnPolicy: "",
  });

  useEffect(() => {
    getSettingJson()
      .then((res) => {
        if (res?.data?.name) setData(JSON.parse(res?.data?.name));
      })
      .catch((err) => console.error(err));
  }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-center">About Us</h1>

      {/* About Company */}
      <section className="mb-10">
        <p className="mb-4">
          <strong>Fivea.in</strong> is your go-to furniture destination offering
          beautifully designed, durable, and affordable products to enhance your
          living and working spaces. Our mission is to provide premium furniture
          solutions that blend style and comfort — without compromising on
          quality.
        </p>
        <p className="mb-4">
          With a strong presence in Vellore, Tamil Nadu, we take pride in
          serving customers both online and at our physical showroom. Our
          commitment is to deliver exceptional products and unmatched customer
          service.
        </p>
      </section>

      {/* Highlights / Values */}
      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {[
          {
            title: "Free Shipping",
            description: "On all orders over ₹500",
          },
          {
            title: "24/7 Support",
            description: "We're here to help anytime",
          },
          {
            title: "30 Days Return",
            description: "Easy and hassle-free",
          },
          {
            title: "Secure Payment",
            description: "100% secure transactions",
          },
        ].map((item, i) => (
          <div
            key={i}
            className="border border-gray-300 p-4 rounded-md shadow-sm hover:shadow-md transition"
          >
            <h4 className="font-semibold text-lg mb-2">{item.title}</h4>
            <p className="text-sm text-gray-600">{item.description}</p>
          </div>
        ))}
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Terms & Conditions</h2>
        <div dangerouslySetInnerHTML={{ __html: data.returnPolicy }}/>
      </section>

      {/* Return Policy */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Return Policy</h2>
        <div dangerouslySetInnerHTML={{__html:data.returnPolicy}}/>
      </section>

      {/* Contact Info */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Contact Information</h2>
        <div className="space-y-2 text-gray-700">
          <p>
            <strong>Support Phone:</strong>
          </p>
          <ul className="ml-4 list-disc">
            <li>
              <a
                href={`tel:${data.phone.split(" ").join("")}`}
                className="text-blue-600 hover:underline"
              >
                {data.phone}
              </a>
            </li>
            <li>
              <a
                href={`tel:${data.phone1.split(" ").join("")}`}
                className="text-blue-600 hover:underline"
              >
                {data.phone}
              </a>
            </li>
            <li>
              <a
                href={`tel:${data.phone2.split(" ").join("")}`}
                className="text-blue-600 hover:underline"
              >
                {data.phone2}
              </a>
            </li>
          </ul>
          <p className="mt-2">
            <strong>Email:</strong>{" "}
            <a
              href={`mailto:${data.email}`}
              className="text-blue-600 hover:underline"
            >
              {data.email}
            </a>
          </p>
        </div>
      </section>

      {/* Store Address */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">Our Showroom</h2>
        <p className="text-gray-700">
          S F No. 47/2, D No.15, Palar Salai,
          <br />
          near OLA Bike Showroom, Virthampet, Katpadi,
          <br />
          Vellore, Tamil Nadu – 632006
        </p>
      </section>

      {/* Embedded Map */}
      <section>
        <h2 className="text-2xl font-semibold mb-4">Find Us on the Map</h2>
        <div className="w-full aspect-video rounded-md overflow-hidden shadow-md">
          <iframe
            title="Fivea Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31107.698002844278!2d79.11523699106579!3d12.942246092088633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad396269e678fd%3A0xf49d15ba35cffb28!2zRml2ZWEgLSBGdXJuaXR1cmUgU2hvd3Jvb20gaW4gVmVsbG9yZSDgroPgrqrgrr_grrXgr43grq_grr4!5e0!3m2!1sen!2sin!4v1752826444891!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
